import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import PropTypes from 'prop-types';

import {
  StyledContentBlock,
  ImageWrapper,
  StyledImage,
  StyledSection,
  Contentwrapper,
  Subtitle,
  Title,
} from './styled';

const MoveMoney = ({ template }) => {
  const { messages, locale } = useIntl();

  return (
    <StyledSection>
      <StyledContentBlock>
        <ImageWrapper>
          <StyledImage
            src={messages[`${template}.move.image.src`]}
            alt={messages[`${template}.move.image.alt`]}
          />
        </ImageWrapper>
        <Contentwrapper>
          <Title locale={locale}>
            <FormattedMessage id={`${template}.move.title`} />
          </Title>
          <Subtitle>
            <FormattedMessage id={`${template}.move.paragraph`} />
          </Subtitle>
        </Contentwrapper>
      </StyledContentBlock>
    </StyledSection>
  );
};

MoveMoney.propTypes = {
  template: PropTypes.string.isRequired,
};

export default MoveMoney;
